/**
 * cn — tiny className combiner.
 *
 * shadcn components normally import `cn` from "@/lib/utils" (clsx +
 * tailwind-merge). This CRA app has no `@/` path alias and doesn't ship those
 * deps, so this is a dependency-free equivalent: flatten, drop falsy values,
 * and join. Good enough for the conditional-class patterns these UI primitives
 * use. Import it with a relative path, e.g. `import { cn } from "../../lib/utils"`.
 */
export function cn(...inputs) {
  return inputs
    .flat(Infinity)
    .filter(Boolean)
    .join(' ');
}
